import React, { PureComponent } from 'react';
import QuestionInput from './QuestionInput';
import { PROCESS_FLOW_REQUIRED_IDS } from './redux/constants';
import PropTypes from 'prop-types';
import moment from 'moment';

class QuestionGroup extends PureComponent {
  state = { answers: {} }

  componentDidMount() {
    const { questions, isDisabled } = this.props;

    if (!isDisabled) {
      // set up validity ref
      this.questionIdValidMap = questions.reduce((result, question) => {
        result[question.id] = false;

        return result;
      }, {});
    }
  }

  /**
   * handles input events, sets state with answers, notifies parent w/ values and validity
   * @param {string} value 
   * @param {number} questionId
   * @param {boolean} isValid 
   */
  handleEvent = (value, questionId, isValid) => {
    const { eventHandler, groupId, coachingFormType } = this.props;

    // update values
    this.setState((state) => {
      return {
        answers: {
          ...state.answers,
          [questionId]: { value, coachingFormType: { id: coachingFormType } },
        }
      };
      // since we will reference the updated state, use callback
    }, () => {
      // update validity
      this.questionIdValidMap = { ...this.questionIdValidMap, [questionId]: isValid };

      // short-circuit, if this field is not valid, no use checking the rest
      const areAllFieldsValid = isValid
        && (coachingFormType === 3 ? PROCESS_FLOW_REQUIRED_IDS.every((req) => this.questionIdValidMap[req]) : true)
        && Object.values(this.questionIdValidMap).every((val) => val);

      // always update parent section
      eventHandler(this.state.answers, groupId, areAllFieldsValid);
    });
  }

  render() {
    const { questions, isDisabled, isErrorTriggered, coachingFormType } = this.props;
    return (
      <div className="ac-question">
        {(isDisabled && !!questions[0]) && (  // shows updated time and author
          <div className="ac-question-header">
            Updated on <span>{moment.utc(questions[0].createdDate).local().format('MM/DD/YYYY hh:mm:ss A')}</span> by <span>{questions[0].createdBy}</span>
          </div>
        )}
        <div className="ac-question-group">
          {questions.map((question) => {
            return (
              <QuestionInput
                key={question.id || question.question.id}
                isDisabled={isDisabled}
                isErrorTriggered={isErrorTriggered}
                coachingFormType={coachingFormType}
                eventHandler={this.handleEvent}
                value={question.answer || (this.state.answers[question.id] && this.state.answers[question.id].value) || ''}
                // answered/unanswered Qs are sent back w/ diff data shape, this spread covers both
                {...question}
                {...question.question}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

QuestionGroup.propTypes = {
  eventHandler: PropTypes.func,
  groupId: PropTypes.string.isRequired,
  questions: PropTypes.array.isRequired,
  coachingFormType: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool,
  isErrorTriggered: PropTypes.bool.isRequired,
};

QuestionGroup.defaultProps = {
  eventHandler: null,
};

export default QuestionGroup;



// WEBPACK FOOTER //
// ./src/features/agent-coaching/QuestionGroup.js